import { StyledSpacer } from '@tink/core/src/components/atoms/Spacer/Spacer';
import { styled } from '../../../core/theme/styled';
import { FlexBox } from '../../atoms/FlexBox/FlexBox';

export type ContainerProps = {
  hasTintedBackground?: boolean;
};

export const Container = styled.div<ContainerProps>`
  width: 100%;
  padding: ${({ theme }) => theme.sizes.xxsmall};
  border-radius: ${({ theme }) => theme.sizes.xxxsmall};
  display: grid;
  grid-template-columns: auto auto 1fr;
  gap: ${({ theme }) => theme.sizes.xsmall};
  color: ${({ theme }) => theme.configuration.primaryTextColor};
  ${({ hasTintedBackground, theme }) =>
    hasTintedBackground &&
    `
      background-color: ${theme.configuration.tintedBackgroundColor};
    `}
  & + ${StyledSpacer} {
    flex: 0 0 auto;
  }
`;

export const TextContainer = styled(FlexBox)`
  justify-content: flex-start;
  align-items: center;
`;

export const IconContainer = styled(FlexBox)`
  width: ${({ theme }) => theme.sizes.xlarge};
  height: ${({ theme }) => theme.sizes.xlarge};
  justify-content: center;
  align-items: center;
`;
